export default __webpack_public_path__ + "static/media/re5.80c819bc.png";